import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import endpoints from "../endpoints";
import api from "../api";

function* commonFunction(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        type: "Web",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield put({ type: `${value.initAction}` });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

// function* commonGetFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}` });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

function* commonPendingBillGetFunction(value) {
  const token = localStorage.getItem("fmsToken");
  const authorization =
    // appConfig.env !== "production"
    //   ? "Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJCaWxsaW5nU2VydmljZSIsIm5hbWUiOiJTbWFydGVyIEhvbWVzIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.pn9ejLRPhMr9f_foDP-zVbFWZqEI2r2vXLU9uFSumDCxExY4J7O_ROwUt0fv6OKg8J-aGUPDjexB6a_71ur9LQ"
    //   :
    `Bearer ${token}`;
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authorization,
        type: "Web",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield put({ type: `${value.initAction}` });
      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchApartmentData() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Total",
    type: "All",
  };

  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
      method: "POST",
      sucessAction: actionTypes.FETCH_APARTMENTDATA_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_APARTMENTDATA_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchAppUserData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    aptId: `${value.value.aptId}`,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/identityservice/society/appusers`,
      method: "POST",
      sucessAction: actionTypes.FETCH_APARTMENTAPPUSERDATA_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_APARTMENTAPPUSERDATA_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);

    return Res;
  } catch (e) {}
}

function* addAppUser(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const token = localStorage.getItem("fmsToken");
  const Type = value?.value?.type;
  const data = {
    societyId: `${fmsUser.society_id}`,
    name: `${value.value.data.member_name}`,
    email: `${value.value.data.emailID}`,
    countrylist: `${value.value.data.isdCode}`,
    mobile: `${value.value.data.mobileNo}`,
    aptId: `${value.value.aptId}`,
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/addAppusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.ADD_APARTMENTAPPUSERDATA_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
        payload: resJSON,
      });
      if (Type == "addAppUser") {
        yield toast.success("WaterOn app user added successfully", {
          autoClose: 3000,
        });
      }
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_APARTMENTAPPUSERDATA_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        const errorText = yield err.json();
        if (Type == "addAppUser") {
          yield toast.error(`${errorText.message}`, {
            autoClose: 3000,
          });
        }
      } else if (err.status === 500) {
      } else {
      }
    }
  }
}

function* deleteAppuser(value) {
  const token = localStorage.getItem("fmsToken");
  const data = {
    isd: `${value.value.isdCode}`,
    mobilenumber: `${value.value.mobileNumber}`,
    aptid: `${value.value.aptId}`,
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/removeAppusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.DELETE_APARTMENTAPPUSERDATA_SUCCESS_ACTION,
        payload: { resJSON: resJSON, rowId: value.value.rowId },
      });
      yield put({
        type: actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
        payload: resJSON,
      });
      toast.success("WaterOn app user deleted successfully");
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_APARTMENTAPPUSERDATA_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateAppUser(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const Ownernumber =
    value?.value?.values?.ownerisd + "-" + value?.value?.values?.ownernumber ||
    "";
  const Residentnumber =
    value?.value?.values?.residentisd +
      "-" +
      value?.value?.values?.residentnumber || "";
  const data = {
    societyId: `${fmsUser.society_id}`,
    apts: [
      {
        aptNo: value?.value?.itemList?.aptNo || "",
        residentName: value?.value?.values?.residentname || "",
        residentEmail: value?.value?.values?.residentemail || "",
        residentPhone: `${Residentnumber}`,
        towerName: value?.value?.itemList?.towerName || "",
        ownerName:
          value?.value?.values?.ownername === ""
            ? value?.value?.values?.residentname
            : value?.value?.values?.ownername,
        ownerEmail:
          value?.value?.values?.owneremail === ""
            ? value?.value?.values?.residentemail
            : value?.value?.values?.owneremail,
        ownerPhone:
          `${Ownernumber}` === "" ? `${Residentnumber}` : `${Ownernumber}`,
      },
    ],
  };
  try {
    let params;
    if (value.value.showToast !== "true") {
      params = {
        api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
        method: "POST",
        sucessAction: actionTypes.UPDATE_APARTMENTAPPUSERDATA_SUCCESS_ACTION,
        initAction: actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
        toastMsg: "Apartment details updated successfully",
        failAction: actionTypes.UPDATE_APARTMENTAPPUSERDATA_FAIL_ACTION,
        body: JSON.stringify(data),
      };
    } else {
      params = {
        api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
        method: "POST",
        sucessAction: actionTypes.UPDATE_APARTMENTAPPUSERDATA_SUCCESS_ACTION,
        initAction: actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
        failAction: actionTypes.UPDATE_APARTMENTAPPUSERDATA_FAIL_ACTION,
        body: JSON.stringify(data),
      };
    }
    const Res = yield call(commonFunction, params);
    return Res;
  } catch (err) {}
}

//COLLECTION

function* generateCollection(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const token = localStorage.getItem("fmsToken");
  const data = {
    societyId: `${fmsUser.society_id}`,
    username: `${fmsUser.username}`,
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/socmailsent`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.GENERATE_COLLECTION_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_COLLECTIONISMAILSENT_INIT_ACTION,
        payload: resJSON,
      });
      yield toast.success("Generated successfully", {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.GENERATE_COLLECTION_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else if (err.status === 404) {
        yield toast.error("Generate failed", { autoClose: 3000 });
      } else {
      }
    }
  }
}

function* collectionIsMailSent() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/identityservice/society/ismailsent`,
      method: "POST",
      sucessAction: actionTypes.FETCH_COLLECTIONISMAILSENT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_COLLECTIONISMAILSENT_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchReGenerate() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/societydataservice/society/getbillcycledetail`,
      method: "POST",
      sucessAction: actionTypes.FETCH_REGENERATE_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_REGENERATE_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchCollectionData() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/societydataservice/society/getcollectiondetails`,
      method: "POST",
      sucessAction: actionTypes.FETCH_COLLECTIONDATA_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_COLLECTIONDATA_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* addRegWaterCard(value) {
  yield toast.success("Bill regeneration initiated", {
    autoClose: 2000,
  });
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const token = localStorage.getItem("fmsToken");
  const data = {
    societyId: fmsUser.society_id,
    month: value?.value?.month,
    year: value?.value?.year,
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/regenerate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.ADD_REGWATERCARD_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_COLLECTIONDATA_INIT_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_COLLECTION_APARTMENTS_INIT_ACTION,
        value: { month: value?.value?.month, year: value?.value?.year },
      });
      yield toast.success("Bill regenerated successfully", {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_REGWATERCARD_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        setTimeout(function () {
          toast.error(`${endpoints.status400}`, {
            autoClose: 3000,
          });
        }, 2000);
      } else if (err.status === 500) {
        setTimeout(function () {
          toast.error("Failed to regenerate the bill", {
            autoClose: 3000,
          });
        }, 2000);
      } else if (err.status === 412) {
        setTimeout(function () {
          toast.error(
            `Bill already sent for ${value?.value?.month}-${value?.value?.year}`,
            {
              autoClose: 3000,
            }
          );
        }, 2000);
      } else {
      }
    } else {
      yield put({
        type: actionTypes.ADD_REGWATERCARD_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* addGenerateWaterCard(value) {
  yield toast.success("Bill generation initiated", {
    autoClose: 2000,
  });
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const token = localStorage.getItem("fmsToken");
  const data = {
    societyId: fmsUser.society_id,
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/createsocbill`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.ADD_GENERATE_WATERCARD_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_COLLECTIONISMAILSENT_INIT_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_COLLECTION_APARTMENTS_INIT_ACTION,
        value: { month: value.value.month, year: value.value.year },
      });
      yield put({
        type: actionTypes.FETCH_COLLECTIONDATA_INIT_ACTION,
        payload: resJSON,
      });
      yield toast.success("Consolidated bill generated and sent successfully", {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_GENERATE_WATERCARD_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        setTimeout(function () {
          toast.error(`${endpoints.status400}`, {
            autoClose: 3000,
          });
        }, 2000);
      } else if (err.status === 500) {
        setTimeout(function () {
          toast.error(`${endpoints.status500}`, {
            autoClose: 3000,
          });
        }, 2000);
      } else if (err.status === 404 || err.status === 304) {
        setTimeout(function () {
          toast.error("Failed to generate", {
            autoClose: 3000,
          });
        }, 2000);
      }
    } else {
      yield put({
        type: actionTypes.ADD_GENERATE_WATERCARD_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* addCollectionPayments(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    socId: fmsUser.society_id,
    payments: value?.value,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/uploadpayment`,
      method: "POST",
      sucessAction: actionTypes.ADD_COLLECTION_PAYMENTS_SUCCESS_ACTION,
      initAction: actionTypes.FETCH_COLLECTIONDATA_INIT_ACTION,
      toastMsg: "Payment info uploaded successfully",
      failAction: actionTypes.ADD_COLLECTION_PAYMENTS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchCollectionApartments(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    month: value.value.month,
    year: value.value.year,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/consolidatedbill`,
      method: "POST",
      sucessAction: actionTypes.FETCH_COLLECTION_APARTMENTS_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_COLLECTION_APARTMENTS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchDownloadWaterData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const month =
    value?.value?.month < 10 ? "0" + value?.value?.month : value?.value?.month;
  const data = {
    societyId: `${fmsUser.society_id}`,
    month: month,
    year: `${value.value.year}`,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/societydataservice/society/getconsolidatedbymonth`,
      method: "POST",
      sucessAction: actionTypes.FETCH_DOWNLOAD_WATER_CARD_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_DOWNLOAD_WATER_CARD_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* consolidatedbBillView(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data =
    value?.payload?.type === "paymentUpdate"
      ? {
          societyId: `${fmsUser.society_id}`,
          aptId: value?.payload?.aptId || null,
          billCycleId: value?.payload?.billCycleId || null,
        }
      : {
          societyId: `${fmsUser.society_id}`,
          aptId: value?.value?.item?.aptId || null,
          billCycleId: value?.value?.selectedMonthAndYear?.billingId || null,
        };

  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/getpayments`,
      method: "POST",
      sucessAction: actionTypes.CONSOLIDATED_BILL_VIEW_SUCCESS_ACTION,
      failAction: actionTypes.CONSOLIDATED_BILL_VIEW_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchPendingBill(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/pendingbill`,
      method: "POST",
      sucessAction: actionTypes.FETCH_PENDING_BILLS_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_PENDING_BILLS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonPendingBillGetFunction, params);

    return Res;
  } catch (e) {}
}

//consumption

function* fetchMeterWiseConsumption(params) {
  const socId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let month = params?.params?.mon || "0";
  const data = {
    societyId: socId,
    mon: month,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/watersourceservice/society/getmeterwiseconsumption`,
      method: "POST",
      sucessAction: actionTypes.FETCH_METER_WISE_CONSUMPTION_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_METER_WISE_CONSUMPTION_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

// ***************************valve Control************************

function* fetchValveControlData(value) {
  const data = {
    aptId: value?.value?.aptId || 0,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valvestatus`,
      method: "POST",
      sucessAction: actionTypes.FETCH_VALVE_CONTROL_DATA_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_VALVE_CONTROL_DATA_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* updateValveControlAction(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    meterId: value?.value?.meterId || 0,
    action: value?.value?.status || "",
    username: `${fmsUser.username}`,
    adminFlag: true,
    userInterface: "admin",
    actionReason: "admin",
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
      method: "POST",
      sucessAction: actionTypes.UPDATE_VALVE_CONTROL_ACTION_SUCCESS_ACTION,
      toastMsg: "Valve " + value.value.status + " initiated",
      failAction: actionTypes.UPDATE_VALVE_CONTROL_ACTION_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonFunction, params);
    if (Res.status == "Success") {
      yield put({
        type: actionTypes.FETCH_VALVE_CONTROL_DATA_INIT_ACTION,
        value: { aptId: value.value.aptId },
      });
    }
    return Res;
  } catch (e) {}
}

function* statusChangeAllValve(value) {
  const rows = value.value.valveControlList;
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let valveLists = [];
  valveLists = rows.filter((item) => {
    return item.valveStatus.toLowerCase() !== value?.value?.value;
  });
  try {
    for (let i = 0; i < valveLists.length; i++) {
      const x = rows[i];
      const data = {
        meterId: x.meterId || 0,
        action: value?.value?.value || "",
        username: `${fmsUser.username}`,
        adminFlag: true,
        userInterface: "admin",
        actionReason: "admin",
      };
      let params = {
        api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
        method: "POST",
        sucessAction: actionTypes.UPDATE_CLOSE_ALL_VALVE_SUCCESS_ACTION,
        failAction: actionTypes.UPDATE_CLOSE_ALL_VALVE_FAIL_ACTION,
        body: JSON.stringify(data),
        initAction: yield put({
          type: actionTypes.FETCH_VALVE_CONTROL_DATA_INIT_ACTION,
          value: { aptId: value.value.aptId },
        }),
      };
      const Res = yield call(commonFunction, params);
      if (Res) {
      }
    }
  } catch (e) {}
}

// ***********************************************Admin Lock****************************************************

function* updateAdminLock(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const token = localStorage.getItem("fmsToken");
  const data = {
    aptId: value?.value?.itemList?.aptId || 0,
    action: value?.value?.value?.action || "",
    username: `${fmsUser.username}`,
    adminFlag: value?.value?.value?.adminflag ? true : false,
    comment: value?.value?.selectedOption || "",
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valvestate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.UPDATE_ADMIN_LOCK_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
        payload: resJSON,
      });
      yield toast.success("Lock status changed successfully", {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_ADMIN_LOCK_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else if (err.status === 404 || err.status === 304) {
        yield toast.error("No meter is available in the apartment", {
          autoClose: 3000,
        });
      }
    }
  }
}

function* fetchAutogenerateStatus() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/autogeneratestatus`,
      method: "POST",
      sucessAction:
        actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* viewAptBillCompact(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const data = {
      aptId: value.value.aptId,
      month: value.value.month,
      year: value.value.year,
    };
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/viewaptbill`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_VIEW_BILL_COMPACT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_VIEW_BILL_COMPACT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* getTemplate() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/identityservice/society/gettemplate`,
      method: "POST",
      sucessAction: actionTypes.FETCH_TEMPLATE_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_TEMPLATE_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);

    return Res;
  } catch (e) {}
}

function* sentApartmentEmail(value) {
  const data = value.value;
  const token = localStorage.getItem("fmsToken");

  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/sendBills`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.SEND_APARTMENT_EMAIL_SUCCESS_ACTION,
        payload: { resJSON: resJSON },
      });
      toast.success("Water Report Card sent successfully");
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.SEND_APARTMENT_EMAIL_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        const errorText = yield err.json();
        yield toast.error(`${errorText.message}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* residentEmailSent(value) {
  const data = value.value;
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/sendBill`,
      method: "POST",
      sucessAction: actionTypes.SEND_RESIDENT_EMAIL_SUCCESS_ACTION,
      toastMsg: "Water Report Card sent successfully",
      failAction: actionTypes.SEND_RESIDENT_EMAIL_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonFunction, params);
    return Res;
  } catch (e) {}
}

function* fetchValveHistory(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    aptId: value?.value?.aptId,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valvehistory`,
      method: "POST",
      sucessAction: actionTypes.FETCH_VALVE_HISTORY_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_VALVE_HISTORY_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* deleteAppUserCheck(value) {
  const token = localStorage.getItem("fmsToken");
  const data = {
    isd: `${value.value.value.isdCode}`,
    mobilenumber: `${value.value.value.mobileNo}`,
    aptid: `${value.value.aptId}`,
  };
  try {
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/removeAppusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.DELETE_APARTMENTAPPUSERDATA_CHECK_SUCCESS_ACTION,
        payload: { resJSON: resJSON, rowId: value.value.rowId },
      });
      yield put({
        type: actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
        payload: resJSON,
      });
      return resJSON;
    }
  } catch (err) {}
}

function* fetchInterimBillDetails(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    aptId: value?.params?.aptId,
    startDate: value?.params?.fromDate,
    endDate: value?.params?.toDate,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/interimbill`,
      method: "POST",
      sucessAction: actionTypes.FETCH_INTERIM_BILLS_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_INTERIM_BILLS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* updateCollectionPayments(value) {
  const data = {
    socId: value?.value?.societyId,
    aptId: value?.value?.apartmentId,
    paymentdate: value?.value?.paymentDate,
    paymentamount: parseFloat(value?.value?.paidAmount).toFixed(2),
    id: value?.value?.paymentId,
  };

  const paymentdata = {
    type: "paymentUpdate",
    societyId: `${value?.value?.societyId}`,
    aptId: value?.value?.apartmentId || null,
    billCycleId: value?.value?.billCycleId || null,
  };

  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/billingservice/society/updatepayment`,
      method: "POST",
      sucessAction: actionTypes.UPDATE_COLLECTION_PAYMENTS_SUCCESS_ACTION,
      toastMsg: "Payment info updated successfully",
      failAction: actionTypes.UPDATE_COLLECTION_PAYMENTS_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonFunction, params);
    yield put({
      type: actionTypes.CONSOLIDATED_BILL_VIEW_INIT_ACTION,
      payload: paymentdata,
    });
    return Res;
  } catch (e) {}
}

export function* apartmentActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_APARTMENTDATA_INIT_ACTION,
    fetchApartmentData
  );
  yield takeEvery(
    actionTypes.FETCH_APARTMENTAPPUSERDATA_INIT_ACTION,
    fetchAppUserData
  );
  yield takeEvery(actionTypes.ADD_APARTMENTAPPUSERDATA_INIT_ACTION, addAppUser);
  yield takeEvery(
    actionTypes.DELETE_APARTMENTAPPUSERDATA_INIT_ACTION,
    deleteAppuser
  );
  yield takeEvery(
    actionTypes.UPDATE_APARTMENTAPPUSERDATA_INIT_ACTION,
    updateAppUser
  );
  yield takeEvery(
    actionTypes.GENERATE_COLLECTION_INIT_ACTION,
    generateCollection
  );
  yield takeEvery(
    actionTypes.FETCH_COLLECTIONISMAILSENT_INIT_ACTION,
    collectionIsMailSent
  );
  yield takeEvery(actionTypes.FETCH_REGENERATE_INIT_ACTION, fetchReGenerate);
  yield takeEvery(
    actionTypes.FETCH_COLLECTIONDATA_INIT_ACTION,
    fetchCollectionData
  );
  yield takeEvery(actionTypes.ADD_REGWATERCARD_INIT_ACTION, addRegWaterCard);
  yield takeEvery(
    actionTypes.ADD_GENERATE_WATERCARD_INIT_ACTION,
    addGenerateWaterCard
  );
  yield takeEvery(
    actionTypes.ADD_COLLECTION_PAYMENTS_INIT_ACTION,
    addCollectionPayments
  );
  yield takeEvery(
    actionTypes.FETCH_COLLECTION_APARTMENTS_INIT_ACTION,
    fetchCollectionApartments
  );
  yield takeEvery(
    actionTypes.FETCH_DOWNLOAD_WATER_CARD_INIT_ACTION,
    fetchDownloadWaterData
  );
  yield takeEvery(
    actionTypes.CONSOLIDATED_BILL_VIEW_INIT_ACTION,
    consolidatedbBillView
  );
  yield takeEvery(
    actionTypes.FETCH_PENDING_BILLS_INIT_ACTION,
    fetchPendingBill
  );
  yield takeEvery(
    actionTypes.FETCH_METER_WISE_CONSUMPTION_INIT_ACTION,
    fetchMeterWiseConsumption
  );
  yield takeEvery(
    actionTypes.FETCH_VALVE_CONTROL_DATA_INIT_ACTION,
    fetchValveControlData
  );
  yield takeEvery(
    actionTypes.UPDATE_VALVE_CONTROL_ACTION_INIT_ACTION,
    updateValveControlAction
  );
  yield takeEvery(
    actionTypes.UPDATE_CLOSE_ALL_VALVE_INIT_ACTION,
    statusChangeAllValve
  );
  yield takeEvery(actionTypes.UPDATE_ADMIN_LOCK_INIT_ACTION, updateAdminLock);
  yield takeEvery(
    actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_INIT_ACTION,
    fetchAutogenerateStatus
  );
  yield takeEvery(
    actionTypes.FETCH_VIEW_BILL_COMPACT_INIT_ACTION,
    viewAptBillCompact
  );
  yield takeEvery(actionTypes.FETCH_TEMPLATE_INIT_ACTION, getTemplate);
  yield takeEvery(
    actionTypes.SEND_APARTMENT_EMAIL_INIT_ACTION,
    sentApartmentEmail
  );
  yield takeEvery(
    actionTypes.SEND_RESIDENT_EMAIL_INIT_ACTION,
    residentEmailSent
  );
  yield takeEvery(
    actionTypes.FETCH_VALVE_HISTORY_INIT_ACTION,
    fetchValveHistory
  );
  yield takeEvery(
    actionTypes.DELETE_APARTMENTAPPUSERDATA_CHECK_INIT_ACTION,
    deleteAppUserCheck
  );
  yield takeEvery(
    actionTypes.FETCH_INTERIM_BILLS_INIT_ACTION,
    fetchInterimBillDetails
  );
  yield takeEvery(
    actionTypes.UPDATE_COLLECTION_PAYMENTS_INIT_ACTION,
    updateCollectionPayments
  );
}
